import { SvgIcon} from "@mui/material";

export default function LeafIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M4 14c6-8 12-8 16-8-2 8-8 12-16 12 4-2 6-4 8-7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
